import { render, staticRenderFns } from "./matter-form.vue?vue&type=template&id=3bf37035&scoped=true&"
import script from "./matter-form.vue?vue&type=script&lang=js&"
export * from "./matter-form.vue?vue&type=script&lang=js&"
import style0 from "./matter-form.vue?vue&type=style&index=0&id=3bf37035&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf37035",
  null
  
)

export default component.exports